import { TenantPill } from "../../components/TenantPill/TenantPill";
import { IconPlus } from "../../components/icons/icons";
import type { Tenant } from "../../types";
import styles from "./TenantTabs.module.css";

interface TenantTabsProps {
  tenants: Tenant[];
  selectedTenantId: string;
  onSelect: (tenantId: string) => void;
  onAddNew?: () => void;
  addingNew?: boolean;
  ariaLabel?: string;
}

export function TenantTabs({
  tenants,
  selectedTenantId,
  onSelect,
  onAddNew,
  addingNew = false,
  ariaLabel = "Your businesses",
}: TenantTabsProps) {
  return (
    <nav className={styles.tabs} aria-label={ariaLabel}>
      {tenants.map((tenant) => (
        <TenantPill
          key={tenant.tenantId}
          label={tenant.name}
          color={tenant.primaryColor}
          logoUrl={tenant.logoUrl}
          active={!addingNew && tenant.tenantId === selectedTenantId}
          suspended={tenant.status === "suspended"}
          onClick={() => onSelect(tenant.tenantId)}
        />
      ))}
      {onAddNew && (
        <button type="button" className={styles.addTab} onClick={onAddNew} aria-pressed={addingNew}>
          <IconPlus width={14} height={14} />
          New business
        </button>
      )}
    </nav>
  );
}
